import { ClientPath } from '@shared/models/client-path.enum';

export const ClientWithLocalSiteConfig: Array<ClientPath> = [
  ClientPath.ABSA,
  ClientPath.ALPHACARD,
  ClientPath.CENTURIONBE,
  ClientPath.BANK_OF_EAST_ASIA,
  ClientPath.BARCLAYCARD,
  ClientPath.BARCLAYS,
  ClientPath.CARLAUREN,
  ClientPath.CENTURION,
  ClientPath.CNB,
  ClientPath.COUTTS,
  ClientPath.CREDIT_ONE,
  ClientPath.DBSAMEX,
  ClientPath.DILLARDS,
  ClientPath.DISCOVER,
  ClientPath.DNB,
  ClientPath.HSBC_JADE,
  ClientPath.HSBC_VISA,
  ClientPath.HSBCCONCIERGE,
  ClientPath.ITAU,
  ClientPath.MASTERCARD_CITI,
  ClientPath.MASTERCARD_HNW,
  ClientPath.MASTERCARD_RAK,
  ClientPath.MASTERCARD,
  ClientPath.NATWEST,
  ClientPath.NAVY_FEDERAL,
  ClientPath.MASTERCARD_NEO,
  ClientPath.OCBC,
  ClientPath.RBC,
  ClientPath.SCOTIA_EVASION,
  ClientPath.SCOTIA_PURSUITS,
  ClientPath.SCOTIA_PLATINUM,
  ClientPath.SCOTIA_GOLD,
  ClientPath.SJPCONCIERGE,
  ClientPath.SNBAR,
  ClientPath.SNBEN,
  ClientPath.SWISSCARD,
  ClientPath.TEN,
  ClientPath.TRANSAMERICA,
  ClientPath.VISA_CEMEA,
  ClientPath.VISA_LAC,
  ClientPath.VODAFONE,
  ClientPath.WELLS_FARGO,
  ClientPath.WESTPAC,
  ClientPath.BANCO_PICHINCHA,
  ClientPath.STANDARD_CHARTERED,
  ClientPath.GINZASIXCARD,
  ClientPath.GTC,
  ClientPath.LUXURY_CARD,
  ClientPath.VISA_US,
  ClientPath.VISA_US_HOLDINGPAGE,
  ClientPath.CREDIT_SAISON_PREMIUM_v2,
  ClientPath.SANTANDER,
  ClientPath.EAB,
  ClientPath.CREDITSAISON,
  ClientPath.CREDIT_SAISON_DIAMOND,
  ClientPath.MANULIFE,
  ClientPath.SMCC,
];

export const ClientWithExternalSiteConfig: Array<ClientPath> = [
  ClientPath.ALPHACARD,
  ClientPath.CENTURIONBE,
  ClientPath.BANCO_PICHINCHA,
  ClientPath.BANK_OF_EAST_ASIA,
  ClientPath.BANK_OF_MELBOURNE,
  ClientPath.BANKSA,
  ClientPath.BARCLAYS,
  ClientPath.CENTURION,
  ClientPath.CREDIT_ONE,
  ClientPath.CREDIT_SAISON_PREMIUM_v2,
  ClientPath.CREDIT_SAISON_DIAMOND,
  ClientPath.CREDITSAISON,
  ClientPath.DILLARDS,
  ClientPath.DISCOVER,
  ClientPath.DNB,
  ClientPath.DNBSAGA,
  ClientPath.HSBCCONCIERGE,
  ClientPath.MORGANSTANLEY,
  ClientPath.NAVY_FEDERAL,
  ClientPath.NOMURA,
  ClientPath.MASTERCARD_NEO,
  ClientPath.SPW,
  ClientPath.STGEORGE,
  ClientPath.WELLS_FARGO,
  ClientPath.WESTPAC,
  ClientPath.SCOTIA_PLATINUM,
  ClientPath.SCOTIA_GOLD,
  ClientPath.BAC,
  ClientPath.RBC_ENTERPRISE,
  ClientPath.STANDARD_CHARTERED,
  ClientPath.QORBIS,
  ClientPath.VISA_TRIAL,
  ClientPath.GTC,
  ClientPath.GINZASIXCARD,
  ClientPath.LUXURY_CARD,
  ClientPath.TEN_SELFREG_BINPROD,
  ClientPath.TEN_SELFREG_EXTERNAL,
  ClientPath.TEN_SELFREG_TMREF1,
  ClientPath.VISA_US,
  ClientPath.VISA_US_HOLDINGPAGE,
  ClientPath.SANTANDER,
  ClientPath.EAB,
  ClientPath.MANULIFE,
  ClientPath.NWB,
  ClientPath.RBSBLACK,
  ClientPath.SMCC,
  // for site creation script
];

export const ClientWithDesignAdminCSS: Array<ClientPath> = [
  // ClientPath.COUTTS,
  // ClientPath.TEN,
  ClientPath.VODAFONE,
  // ClientPath.CENTURION,
  // ClientPath.BANKSA,
];

export const ClientWithExternalSiteCSS: Array<ClientPath> = [
  ClientPath.ALPHACARD,
  ClientPath.CENTURIONBE,
  ClientPath.BANCO_PICHINCHA,
  ClientPath.BANK_OF_EAST_ASIA,
  ClientPath.BANK_OF_MELBOURNE,
  ClientPath.BANKSA,
  ClientPath.BARCLAYS,
  ClientPath.CENTURION,
  ClientPath.CREDIT_ONE,
  ClientPath.CREDIT_SAISON_PREMIUM_v2,
  ClientPath.CREDIT_SAISON_DIAMOND,
  ClientPath.CREDITSAISON,
  ClientPath.DILLARDS,
  ClientPath.DISCOVER,
  ClientPath.DNB,
  ClientPath.DNBSAGA,
  ClientPath.HSBCCONCIERGE,
  ClientPath.ITAU,
  ClientPath.MORGANSTANLEY,
  ClientPath.NAVY_FEDERAL,
  ClientPath.NOMURA,
  ClientPath.MASTERCARD_NEO,
  ClientPath.SNBAR,
  ClientPath.SNBEN,
  ClientPath.SPW,
  ClientPath.STGEORGE,
  ClientPath.WELLS_FARGO,
  ClientPath.WESTPAC,
  ClientPath.SCOTIA_PLATINUM,
  ClientPath.SCOTIA_GOLD,
  ClientPath.BAC,
  ClientPath.RBC_ENTERPRISE,
  ClientPath.STANDARD_CHARTERED,
  ClientPath.QORBIS,
  ClientPath.VISA_TRIAL,
  ClientPath.GTC,
  ClientPath.GINZASIXCARD,
  ClientPath.LUXURY_CARD,
  ClientPath.TEN_SELFREG_BINPROD,
  ClientPath.TEN_SELFREG_EXTERNAL,
  ClientPath.TEN_SELFREG_TMREF1,
  ClientPath.VISA_US,
  ClientPath.VISA_US_HOLDINGPAGE,
  ClientPath.SANTANDER,
  ClientPath.EAB,
  ClientPath.MANULIFE,
  ClientPath.NWB,
  ClientPath.RBSBLACK,
  ClientPath.SMCC,
  // for site creation script
];
